export default "__VITE_ASSET__D0bOsE9V__"